import { Card, Icon, Tooltip } from "@mui/material";
import SoftButton from "components/SoftButton";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api } from "utils/Api";
import DetailBox from "utils/Detail-Box/DetailBox";
import AdminUnitData from "./Units/AdminUnits";
import AdminTenant from "./Tenant/AdminTenant";
import { useAuth } from "context/AuthContext";
import { useHierarchy } from "context/HierarchyContext";
import { useSoftUIController, setOpenShiftLog, setOpenConfigurator } from "context";
import { getSecureItem } from "utils/SecureStorage";
import AdminManagers from "../Properties-detail/Manager/AdminManagers";
import AdminConcierge from "../Properties-detail/Concierge/AdminConcierge";

function PropertyDetail() {
  const { orgId, propertyCode, unitDetailTab } = useParams();
  const navigate = useNavigate();

  // STATE — Parent owns all property data
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { propertyId, setPropertyId, setOrgId } =  useHierarchy();
  const { isAdmin, isManager, isUser, isStaff, updateRole } = useAuth();
  const [controller, dispatch] = useSoftUIController();
  const { openConfigurator } = controller;
  const activeTab = unitDetailTab || "unit";
  const [orgIdFromUrl, setOrgIdFromUrl] = useState(null);
  const handleSupportOpen = () => { setOpenConfigurator(dispatch, true); };

  const propertyCodeFromUrl = searchParams.get("property_code");

  // FETCH LOGIC — Role-based
  // useEffect(() => {
  //   const fetchProperties = async () => {
  //     try {
  //       if (isUser || isStaff) {
  //         const response = await api.properties.getProperties();
  //         const list = response || [];
  //         setProperties(list);

  //         if (propertyCodeFromUrl) {
  //           const matched = list.find(
  //             (p) => p.property_code === propertyCodeFromUrl
  //           );

  //           if (matched) {
  //             setSelectedProperty(matched);
  //             setPropertyId(matched.id);
  //             return;
  //           }}

  //         // fallback
  //         if (list.length > 0) {
  //           setSelectedProperty(list[0]);

  //           setSearchParams({
  //             property_code: list[0].property_code,
  //           });
  //         }
  //       } else {
  //         const response = await api.properties.getPropertyDetails(propertyId);

  //         setProperties(response ? [response] : []);
  //         setSelectedProperty(response || null);
  //       }
  //     } catch (error) {
        
  //     }
  //   };

  //   if (propertyId || isUser || isStaff) {
  //     fetchProperties();
  //   }
  // }, [propertyId, isUser, isStaff, propertyCodeFromUrl]);

  // useEffect(() => {
  //   const fetchProperties = async () => {
  //     try {
  //       // 👤 USER → Multi-org property list
  //       if (isUser) {
  //         const response = await api.multiOrgProperty.getMultiOrgProperties();
  //         const list = response || [];
  //         setProperties(list);

  //         if (propertyCodeFromUrl) {
  //           const matched = list.find((p) => p.property_code === propertyCodeFromUrl);

  //           if (matched) {
  //             setOrgIdFromUrl(matched.organization_id);
  //             setSelectedProperty(matched);
  //             setPropertyId(matched.id);
  //             setOrgId(matched.organization_id);
  //             return;
  //           }
  //         }

  //         // fallback
  //         if (list.length > 0) {
  //           setSelectedProperty(list[0]);
  //           setSearchParams({
  //             property_code: list[0].property_code,
  //           });
  //         }
  //       }

  //       // 👑 NOT USER → Single property detail
  //       else if (propertyId) {
  //         const response = await api.properties.getPropertyDetails(propertyId);

  //         if (response) {
  //           setOrgIdFromUrl(response.organization_id);
  //           setProperties([response]);
  //           setSelectedProperty(response);
  //         }
  //       }
  //     } catch (error) {
  //     }
  //   };

  //   fetchProperties();
  // }, [isUser, propertyId, propertyCodeFromUrl]);

  useEffect(() => {
  const fetchProperties = async () => {
    try {
      const response = await api.multiOrgProperty.getMultiOrgProperties();
      const list = response || [];

      setProperties(list);

      let matchedProperty = null;

      if (propertyCode) {
        matchedProperty = list.find(
          (p) => p.property_code === propertyCode
        );
      }

      if (!matchedProperty && list.length > 0) {
        matchedProperty = list[0];
      }

      if (matchedProperty) {
        const org = matchedProperty.organization_id;
        const prop = matchedProperty.id;

        setSelectedProperty(matchedProperty);

        setOrgId(org);
        setPropertyId(prop);

        setOrgIdFromUrl(org);
        // updateRole(matchedProperty.role_id);
      }

    } catch (error) {
    }
  };

  fetchProperties();
}, [propertyCode]);

const roleId = selectedProperty?.role_id 

  // Default tab redirect
  useEffect(() => {
    if (!unitDetailTab && (orgId || isUser || isStaff)) {
      // console.log('propertyCode: ', propertyCode);
      navigate(
        isAdmin
          ? `/admin/properties/${propertyCode}/unit`
          : isManager
            ? `/manager/properties/${propertyCode}/unit`
            : isUser
              ? `/user/properties/${propertyCode}/unit`
              : isStaff
                ? `/concierge/unit`
                : "/unauthorized",
        { replace: true }
      );
    }
  }, [unitDetailTab, orgId, propertyId, isAdmin, isManager, isUser, isStaff, navigate]);

  // SELECTION HANDLER — User only, NO URL modification
  const handleSelectProperty = (prop) => {
    setSelectedProperty(prop);
    setPropertyId(prop.id);
    setSelectorOpen(false);

    setSearchParams({
      property_code: prop.property_code,
    });
  };

  // Compute the propertyId to pass to children
  const activePropertyId = isUser || isStaff
  ? selectedProperty?.id
  : propertyId;
  
  const getTabStyle = (isActive) => ({
    px: 3,
    ml: 1,
    borderRadius: "8px",
    fontWeight: 600,
    backgroundColor:"#ffffff",
    color: "#9e9e9e",
    border: "2px solid",
    borderColor: "#e0e0e0",
    borderBottom: "none",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: "0 2px 6px rgba(3,169,244,0.15)",
    "&:hover": {
      backgroundColor: isActive ? "#e1f5fe" : "#fafafa",
    },
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/*  DETAIL BOX with conditional selector */}
      <DetailBox
        title={selectedProperty ? `${selectedProperty.name} (${selectedProperty.property_code})` : "Property Details"}
        data={selectedProperty || {}}
        inputs={[
          { label: "City", key: "city" },
          { label: "State", key: "state" },
          { label: "Country", key: "country" },
          { label: "Pincode", key: "pin_code" },
          { label: "Description", key: "description" },
        ]}
      />

      {/*  TAB BAR */}
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          mb: 1,
          p: 1,
          background: "#f5f7fa",
          borderRadius: "10px",
          width: "fit-content",
        }}
      >
        {/* {(isAdmin || isManager || isStaff) && (
          <SoftButton
            key="shift-log-btn"
            size="small"
            onClick={() => setOpenShiftLog(dispatch, true)}
            startIcon={<Icon>book</Icon>}
            sx={getTabStyle(openConfigurator)}
          >
            Shift Notes
          </SoftButton>
        )} */}

        {/* {(isAdmin || isManager || isStaff) && (
          <SoftButton
            size="small"
            sx={getTabStyle(openConfigurator)}
            onClick={handleSupportOpen}
            startIcon={<Icon>support_agent</Icon>}
          >
            Support
          </SoftButton>
        )} */}

        <SoftButton
          onClick={() =>
            navigate(
              isAdmin
                ? `/admin/properties/${propertyCode}/unit`
                : isManager
                ? `/manager/properties/${propertyCode}/unit`
                : isUser
                ? `/user/properties/${propertyCode}/unit`
                : isStaff
                ? `/concierge/unit`
                : "/unauthorized"
            )
          }
          size="small"
          sx={{
            ml: 1,
            px: 3,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor: activeTab === "unit" ? "#e3f2fd" : "#ffffff",
            color: activeTab === "unit" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor: activeTab === "unit" ? "#b3e5fc" : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: activeTab === "unit" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
            "&:hover": {
              backgroundColor: activeTab === "unit" ? "#e1f5fe" : "#fafafa",
            },
          }}
        >
          Unit
        </SoftButton>

        {!isUser && (
          <SoftButton
            onClick={() =>
              navigate(
                isAdmin
                  ? `/admin/properties/${propertyCode}/residents`
                  : isManager
                  ? `/manager/properties/${propertyCode}/residents`
                  : isUser
                  ? { pathname: `/user/properties/${propertyCode}/residents`, search: `?${searchParams.toString()}` }
                  : isStaff
                  ? { pathname: `/concierge/unit/residents`, search: `?${searchParams.toString()}` }
                  : "/unauthorized"
              )
            }
            size="small"
            sx={{
              px: 3,
              ml: 1,
              borderRadius: "8px",
              fontWeight: 600,
              backgroundColor: activeTab === "residents" ? "#e3f2fd" : "#ffffff",
              color: activeTab === "residents" ? "#03a9f4" : "#9e9e9e",
              border: "2px solid",
              borderColor: activeTab === "residents" ? "#b3e5fc" : "#e0e0e0",
              borderBottom: "none",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              boxShadow: activeTab === "residents" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
              "&:hover": {
                backgroundColor: activeTab === "residents" ? "#e1f5fe" : "#fafafa",
              },
            }}
          >
            Residents
          </SoftButton>
        )}
        
        
          <SoftButton
            onClick={() => navigate(isAdmin ? `/admin/properties/${propertyCode}/managers` : isManager ? `/manager/properties/${propertyCode}/managers` : isStaff ? `/concierge/unit/managers` : isUser ? `/user/properties/${propertyCode}/managers` : `/unauthorized`)}
            size="small"
            sx={{
              px: 3,
              ml: 1,
              borderRadius: "8px",
              fontWeight: 600,
              backgroundColor: activeTab === "managers" ? "#e3f2fd" : "#ffffff",
              color: activeTab === "managers" ? "#03a9f4" : "#9e9e9e",
              border: "2px solid",
              borderColor: activeTab === "managers" ? "#b3e5fc" : "#e0e0e0",
              borderBottom: "none",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              boxShadow: activeTab === "managers" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
              "&:hover": {
                backgroundColor: activeTab === "managers" ? "#e1f5fe" : "#fafafa",
              },
            }}
          >
            Managers
          </SoftButton>

        {!isStaff && (<SoftButton
          onClick={() => navigate(isAdmin ? `/admin/properties/${propertyCode}/concierge` : isManager ? `/manager/properties/${propertyCode}/concierge` : isStaff ? `/concierge/unit/concierge` : isUser ? `/user/properties/${propertyCode}/concierge` : `/unauthorized`)}
          size="small"
          sx={{
            px: 3,
            ml: 1,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor: activeTab === "concierge" ? "#e3f2fd" : "#ffffff",
            color: activeTab === "concierge" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor: activeTab === "concierge" ? "#b3e5fc" : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: activeTab === "concierge"
              ? "0 2px 6px rgba(3,169,244,0.15)"
              : "none",
            "&:hover": {
              backgroundColor:
                activeTab === "concierge" ? "#e1f5fe" : "#fafafa",
            },
          }}
        >
          Concierge
        </SoftButton>)}
      </Card>

      {activePropertyId && activeTab === "unit" && (
        <AdminUnitData propertyId={activePropertyId} orgId={orgIdFromUrl} roleId={roleId} />
      )}
      {activePropertyId && activeTab === "residents" && (
        <AdminTenant propertyId={activePropertyId} />
      )}

      {activePropertyId && activeTab === "managers" && (
        <AdminManagers propertyId={activePropertyId} />
      )}

      {activePropertyId && activeTab === "concierge" && (
        <AdminConcierge propertyId={activePropertyId} />
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default PropertyDetail;